const aaa = [
{
		path: "tiaoma",
		component: () => import("@/views/caigou/tiaoma/tiaoma.vue"),
		meta:{title:'条码追踪'},
	},
]
export default aaa;